import React from 'react';
import ContestMake from '@Builder/myContest/make/ContestMake';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { AppState } from '@Redux/store';
import { Dispatch } from '@Redux/type';
import { connect } from 'react-redux';
import { container } from '@Container';
import { TYPES } from '@Types';
import { MyContestAction } from '@Redux/actions';
import { myContestPresenter } from '@Selectors/tournament/myContest/common/myContestPresenter';
import AddTeam from '@Builder/myContest/team/AddTeam';
import AddParticipant from '@Builder/myContest/user_apply/AddParticipant';
import ContestDelete from '@Builder/myContest/delete/ContestDelete';
import { Link, useParams } from 'react-router-dom';
import myContestSlice from '@Redux/reducers/tournament/myContest.slice';
import { MyContestStateAction } from '@Stores/tournament/MyContestState';

const MyContestPageMake: React.FC<MyContestPageMakeProps> = ({
                                                                   myContest,
                                                                   loadMyContest,
                                                                   requestAddTeam,
                                                                   requestedAddTeam,
                                                                   requestAddParticipant,
                                                                   requestedAddParticipant,
                                                                   toMake,
                                                                   requestedDelete,
                                                                   requestDelete,
                                                                 }) => {

  const params = useParams();
  const contestId = params.contest_id;

  if (!contestId) {
    return <div>
      Contest not found!
    </div>
  }

  React.useEffect(() => {
    loadMyContest(contestId);
  }, []);

  let content = <ContestMake/>;
  if (requestedAddTeam) content = <AddTeam/>;
  if (requestedAddParticipant) content = <AddParticipant/>;
  if (requestedDelete) content = <ContestDelete />

  return <div>
    <div className="army_list row">
      <div className="col-12 col-md-2 mt-1 text-center">
        <a href="#" onClick={() => toMake()}><i className="fas fa-clipboard-list fa-2x"/></a>
        <a href="#" onClick={() => requestAddTeam()}><i className="fas fa-user-friends fa-2x"/></a>
        <a href="#" onClick={() => requestAddParticipant()}><i className="fas fa-user-plus fa-2x"/></a>
      </div>

      <div className="col-12 col-md-8 mt-1 d-flex flex-row">
      </div>

      <div className="col-12 col-md-2 mt-1 mb-1 text-center">
        <a href="#" onClick={() => requestDelete()}><i className="fas fa-trash fa-2x"/></a>
      </div>
    </div>

    <Breadcrumb>
      <BreadcrumbItem>
        <Link to={`/${document.documentElement.lang}/builder/army_lists`}>
          <i className="fa-solid fa-house"></i>
        </Link>
      </BreadcrumbItem>
      <BreadcrumbItem active>{myContest.name}</BreadcrumbItem>
    </Breadcrumb>

    {content}
  </div>;
}


const mapStateToProps = (state: AppState) => ({
  myContest: myContestPresenter(state),
  requestedAddTeam: MyContestStateAction.REQUEST_ADD_TEAM === state.myContest.action,
  requestedAddParticipant: MyContestStateAction.REQUEST_ADD_PARTICIPANT === state.myContest.action,
  requestedDelete: MyContestStateAction.REQUEST_DELETE === state.myContest.action,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const contestAction = container.get<MyContestAction>(TYPES.Actions.MyContestAction);
  return {
    loadMyContest: (id: string) => dispatch(contestAction.fetchData({entityId: id})),
    toMake: () => dispatch(myContestSlice.actions.cancel()),
    requestAddTeam: () => dispatch(myContestSlice.actions.setRequest(MyContestStateAction.REQUEST_ADD_TEAM)),
    requestAddParticipant: () => dispatch(myContestSlice.actions.setRequest(MyContestStateAction.REQUEST_ADD_PARTICIPANT)),
    requestDelete: () => dispatch(myContestSlice.actions.setRequest(MyContestStateAction.REQUEST_DELETE))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(MyContestPageMake);

type MyContestPageMakeProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
